export const challengeSorter = (a, b) => {
  // 1. Scheduled challenges at the top
  if (a.scheduled !== b.scheduled) {
    return b.scheduled - a.scheduled; // scheduled (true/1) comes before unscheduled (false/0)
  }

  // 2. Completed challenges towards the bottom (among non-scheduled or among scheduled)
  const aCompleted = !!a.completedTs;
  const bCompleted = !!b.completedTs;
  
  if (aCompleted !== bCompleted) {
    return aCompleted - bCompleted; // non-completed (false/0) comes before completed (true/1)
  }

  // 3. If both are completed, sort by completion time (most recent first)
  if (aCompleted && bCompleted && a.completedTs !== b.completedTs) {
    return b.completedTs - a.completedTs;
  }

  // 4. If neither are completed, sort by days left (fewer days first)
  if (!aCompleted && !bCompleted && a.daysLeft !== b.daysLeft) {
    return a.daysLeft - b.daysLeft;
  }

  // 5. Finally, sort by name as tie-breaker
  return a.challengeName.localeCompare(b.challengeName);
}
